import * as Ark from './Ark'
import * as Devices from './devices'
import * as Eventspace from './eventspace'
import * as helpers from './helpers'
import * as InRun from './inrun'
import * as LargeVision from './LargeVision'
import * as LiftAndLearn from './liftandlearn'
import * as Notes from './notes'
import * as Media from './media'
import * as Minivision from './minivision'
import * as Playlists from './playlists'
import * as WFH from './WFH'
import * as Wow from './wow'
import * as JLP from './JLP'
import * as EventSpace2 from './EventSpace2'

export * from './Ark'
export * from './devices'
export * from './eventspace'
export * from './inrun'
export * from './LargeVision'
export * from './liftandlearn'
export * from './notes'
export * from './media'
export * from './minivision'
export * from './playlists'
export * from './WFH'
export * from './wow'
export * from './JLP'
export * from './EventSpace2'

/**
 * @deprecated Use every dashboard action type export
 */
export const Types = {
    ...Ark.ArkActionTypes,
    ...Devices.Types,
    ...Eventspace.Types,
    ...helpers.Types,
    ...InRun.Types,
    ...LargeVision.LargeVisionActionTypes,
    ...LiftAndLearn.Types,
    ...Notes.Types,
    ...Media.Types,
    ...Minivision.Types,
    ...Playlists.Types,
    ...WFH.Types,
    ...Wow.Types,
    ...JLP.JLPActionTypes,
    ...EventSpace2.EventSpace2ActionTypes
}
